// require('dotenv').config({path: '.env'});

import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getAuth } from 'firebase/auth'

// const firebaseConfig = {
//     apiKey: "AIzaSyCrtzknDcKYx4HYsQrq4I_EKrdZ9L7W7KU",
//     authDomain: "project-vue-1-661f2.firebaseapp.com",
//     databaseURL: "https://project-vue-1-661f2-default-rtdb.firebaseio.com",
//     projectId: "project-vue-1-661f2",
//     storageBucket: "project-vue-1-661f2.appspot.com",
//     messagingSenderId: "67869292952",
//     appId: "1:67869292952:web:7fbf719a81e74a4c9c93ed"
// };

const firebaseConfig = {
    apiKey: "AIzaSyC5X3Pv-LXTwOE_cbsKisBJjP6oxbgLjs4",
    authDomain: "phatdattravel-a9455.firebaseapp.com",
    projectId: "phatdattravel-a9455",
    storageBucket: "phatdattravel-a9455.appspot.com",
    messagingSenderId: "1068205119042",
    appId: "1:1068205119042:web:e0aa1b852f1580d5843fdb",
    measurementId: "G-0V3ZL0EC0J"
};

// const firebaseConfig = {
//     apiKey: process.env.API_KEY,
//     authDomain: process.env.AUTH_DOMAIN,
//     databaseURL: process.env.DATABASE_URL,
//     projectId: process.env.PROJECT_ID,
//     storageBucket: process.env.STORAGE_BUCKET,
//     messagingSenderId: process.env.MESSAGING_SENDER_ID,
//     appId: process.env.APP_ID
// }
// console.log(process.env.API_KEY);
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const storage = getStorage(app);
const auth = getAuth(app)

export {database, storage, auth}